import { gql } from '@apollo/client';

const schema = {
  createTransaction: {
    name: 'createTransaction',
    serviceName: 'auth',
    query: gql`
      mutation createTransaction(
        $type: String!
        $amount: String
        $order_id: String
        $ref_code: String
        $wallet_id: String
        $description: String
        $settlementor_shop_id: String
      ) {
        createTransaction(
          type: $type
          amount: $amount
          order_id: $order_id
          ref_code: $ref_code
          wallet_id: $wallet_id
          description: $description
          settlementor_shop_id: $settlementor_shop_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
